<icon class="fullscreen-icon" name="fullscreen_enter" (click)="toggleWindowMode()" *ngIf="!isFullScreen"></icon>
<icon class="fullscreen-icon" name="fullscreen_leave" (click)="toggleWindowMode()" *ngIf="isFullScreen"></icon>